export default defineNuxtRouteMiddleware(() => {
	const store = useAdminAuthStore()
	const localePath = useLocalePath()
	if (!store.state.user) {
		return navigateTo(localePath('/panel/login'))
	} else if (!store.getPermission([EUserPermissions.CMS_PL, EUserPermissions.CMS_EN])) {
		return navigateTo(localePath('/panel/login'))
	}
})
